import React from "react"
import { RawCheckbox } from "../../../../../ui/atoms/CustomCheckbox"

interface Props {
  count: number
  label: string
  selected: boolean
  onClick?: () => void
}

const CheckboxFilterItem = ({ count, label, selected, onClick }: Props) => {
  const disabled = count === 0
  return (
    <RawCheckbox
      value={selected}
      onChange={() => onClick?.()}
      className="py-4 sm:py-3"
      labelClassName="text-base truncate"
      alignTop={false}
      disabled={disabled}
    >
      {label} ({count})
    </RawCheckbox>
  )
}

export default CheckboxFilterItem
